import React from 'react';
import { motion } from 'framer-motion';
const metrics = [{
  value: '70%',
  label: 'Margen de ganancia por focaccia'
}, {
  value: '$3.690',
  label: 'Ganancia promedio por unidad vendida'
}, {
  value: '30 días',
  label: 'Para tu primera venta siguiendo el método'
}];
export function MetricsSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-[#2A1E0F] relative border-y border-white/5" data-id="element-125">
      <div className="max-w-6xl mx-auto" data-id="element-126">
        <div className="grid sm:grid-cols-3 gap-12 text-center" data-id="element-127">
          {metrics.map((metric, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-128">
              <span className="text-5xl md:text-6xl font-serif font-bold text-gold mb-4" data-id="element-129">
                {metric.value}
              </span>
              <span className="text-cream-muted text-lg max-w-[200px] leading-snug" data-id="element-130">
                {metric.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}